import Clientes from "./Clientes";
export default Clientes;